import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'
import { useState } from 'react'
import Logo from './Logo'
import MainNav from './MainNav'
import MobileStores from './MobileStores'
// import Federal from './Federal'
import Certification from './Certification'
// import USStocksWatchList from './us-stocks-watch-list'
// import MFWatchList from './mf-watch-list'
import ArrowDown from '@/assets/common/arrowDown.inline.svg'
import FooterSEOLinks from '@/components/Common/FooterV2/FooterSEOLinks'
import { useUserRQInfo } from '@/components/Common/user-provider/user-provider'
import {
  BETA_INDSTOCKS_HOST,
  INDGLOBAL_HOST,
  INDSTOCKS_HOST,
} from '@/root/constants/common'
import { categoryRoutes } from '@/root/utils/common/functions/get-category-from-path'
import AppRating from './AppRating'
import { hideComplianceInfoCategories } from './data/hide-compliance-info-categories'
import SocialIconsV2 from './SocialIconsV2'

const LogoSocialLinksAppStoreIcons = () => {
  return (
    <div className="mb-10 w-full">
      <div className="mb-3 lg:mb-5">
        <Logo />
      </div>
      <div className="mb-4 flex flex-col gap-2 md:mb-6 md:w-4/5 lg:w-3/5">
        <MobileStores cssStyle="!flex-row" />
        <AppRating />
      </div>

      <SocialIconsV2 />
    </div>
  )
}

const showFullFooterForTheseBaseDirectories = [
  'stocks',
  'mutual-funds',
  'fixed-deposit',
  'us-stocks',
  'insurance',
]

type Props = {
  host?: string
  isInMobile?: boolean
}

export default function Footer(props: Props) {
  const { isAuthenticated } = useUserRQInfo()
  const router = useRouter()
  const { isInMobile } = props

  const pathParams = router.asPath.split('/').filter(Boolean)

  const showComplianceInfo = !hideComplianceInfoCategories.find(
    category => categoryRoutes[category] === router.route,
  )
  const IndGlobalFooter = dynamic(() => import('./IndGlobalFooter/Footer'))
  const INDStocksFooter = dynamic(() => import('./IndStocksFooter/Footer'))
  const FooterAboutIndmoney = dynamic(() => import('./FooterAboutIndmoney'))

  const initShowAboutINDMoney =
    // is home page
    pathParams.length === 0 ||
    // is main root page
    (pathParams.length === 1 &&
      showFullFooterForTheseBaseDirectories.includes(pathParams[0]))

  const [showAboutIndMoney, setShowIndMoney] = useState(initShowAboutINDMoney)

  if (props.host === INDSTOCKS_HOST || props.host === BETA_INDSTOCKS_HOST) {
    return <INDStocksFooter />
  }

  if (props.host === INDGLOBAL_HOST) {
    return <IndGlobalFooter />
  }

  return (
    <footer className="bg-brand-black text-brand-white text-13px">
      {/* <div className="flex flex-col md:flex-row max-w-7xl mx-auto pt-11 px-6 md:px-auto md:pt-26 md:pb-10"> */}
      <div className="md:pt-26 herolike-wrapper pt-11 md:pb-10">
        <aside className="flex w-full flex-col md:flex-row md:space-x-5">
          <div className="flex w-full flex-col justify-between md:w-1/2">
            <LogoSocialLinksAppStoreIcons />

            <p className="mb-5">All Rights Reserved | © Copyright 2025</p>
          </div>

          <div className="w-full md:w-1/2">
            <MainNav />
          </div>
        </aside>

        {!isAuthenticated && (
          <div className="pt-16">
            <hr className="border-brand-grey-dark mt-12 pb-12" />
            {/* <p className=" pb-12 text-xl">Popular on INDmoney</p> */}
            {/* <SEOPods /> */}
            <FooterSEOLinks isInMobile={isInMobile} />
            {showComplianceInfo && (
              <>
                <hr className=" border-brand-grey-dark mt-16  pb-16" />
                <aside className="flex w-full flex-col md:flex-row md:space-x-5">
                  <div className="">
                    <p
                      className=" flex !cursor-pointer items-center pb-3 text-xl "
                      onClick={() => setShowIndMoney(!showAboutIndMoney)}
                    >
                      <span className=" pr-2 ">About INDmoney</span>{' '}
                      <ArrowDown width="20" height="20" />
                    </p>
                    {showAboutIndMoney && <FooterAboutIndmoney />}
                  </div>
                </aside>
              </>
            )}
          </div>
        )}
      </div>

      {!isAuthenticated && (
        <section className="bg-brand-white">
          <div className="mx-auto flex flex-col justify-center px-2 pt-4 lg:max-w-[853px] lg:px-8 lg:py-8">
            <span className="text-brand-grey-base my-5 w-full text-center font-medium">
              {/* We hold ISO Information Security Management System ISO/IEC
              27001:2022 certification. */}
            </span>
            <Certification />
          </div>

          {/* <USStocksWatchList /> */}
          {/* <MFWatchList /> */}
        </section>
      )}
    </footer>
  )
}
